module.exports = __webpack_public_path__ + "img/credit_card_icon.45e70a33.svg";